import __request__ from "routing/request";
export function list() {
  return __request__("GET", "/system/inputs", null, {}, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody, setup_wizard = false) {
  return __request__("POST", "/system/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  });
}
export function diagnostics(inputId) {
  return __request__("GET", `/system/inputs/diagnostics/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function pipelineMetadataBulk(JSONbody) {
  return __request__("POST", "/system/inputs/meta/retrieve", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function pipelineMetadata(inputId) {
  return __request__("GET", `/system/inputs/meta/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getPage(sort = "title", page = 1, per_page = 50, query, filters, order = "asc") {
  return __request__("GET", "/system/inputs/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function getReferences(inputId) {
  return __request__("GET", `/system/inputs/references/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function terminate(inputId) {
  return __request__("DELETE", `/system/inputs/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function get(inputId) {
  return __request__("GET", `/system/inputs/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(JSONbody, inputId) {
  return __request__("PUT", `/system/inputs/${inputId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
